import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {ReactElement} from 'react';

import getConfig from '../../load_config';

const QueryDevtools = (): ReactElement | null => {
  const config = getConfig();

  return !config.isProduction ? <ReactQueryDevtools /> : null;
};

export default QueryDevtools;
